export const HomeMeta = { title: 'Home' };
